<template>
  <!-- 主要设备 -->
  <div>
    <div class="fourthStep">
      <el-form
        ref="extTable"
        :model="{ extTable }"
        :rules="tableRules"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item class="addTabIndex" label-width="0px" label="" prop="">
          <div class="table_title">主要设备</div>
          <el-table
            border
            :data="extTable"
            class="ccui-form-child-table"
            max-height="99999"
          >
            <el-table-column
              type="index"
              label="序号"
              width="60"
              fixed>
            </el-table-column>
            <el-table-column prop="formType" label="设备名称" min-width="250px">
              <template slot-scope="scope">
                <el-form-item
                  :prop="`extTable.${scope.$index}.deviceName`"
                  :rules="tableRules.deviceName"
                >
                  <el-input
                    style="width: 230px"
                    v-model="scope.row.deviceName"
                    placeholder="请输入"
                    clearable
                    maxlength="100"
                  />
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="titleName" label="型号规格" min-width="180px">
              <template slot-scope="scope">
                <el-form-item
                  :prop="`extTable.${scope.$index}.modelSpec`"
                  :rules="tableRules.modelSpec"
                >
                  <el-input
                    style="width: 160px"
                    v-model="scope.row.modelSpec"
                    placeholder="请输入"
                    clearable
                    maxlength="100"
                  />
                </el-form-item>
              </template>
            </el-table-column>

            <el-table-column prop="remark" label="品牌" min-width="180px">
              <template slot-scope="scope">
                <el-form-item
                  :prop="`extTable.${scope.$index}.brand`"
                  :rules="tableRules.brand"
                >
                  <el-input
                    style="width: 160px"
                    v-model="scope.row.brand"
                    placeholder="请输入"
                    clearable
                    maxlength="100"
                  />
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="数量"  min-width="130px">
              <template slot-scope="scope">
                <el-form-item
                  :prop="`extTable.${scope.$index}.num`"
                  :rules="tableRules.num"
                >
                  <el-input
                    style="width: 110px"
                    v-model="scope.row.num"
                    placeholder="请输入"
                    clearable
                    @input="scope.row.num=scope.row.num.replace(/^(0+)|[^\d]+/g,'')"
                    maxlength="9"
                  />
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="出厂年限" width="180px;">
              <template slot-scope="scope">
                <el-form-item
                  :prop="`extTable.${scope.$index}.buyYear`"
                  :rules="tableRules.buyYear"
                >
                  <el-date-picker
                    style="width: 160px;"
                    v-model="scope.row.buyYear"
                    value-format="yyyy"
                    type="year"
                    placeholder="请选择出厂年限"
                  >
                  </el-date-picker>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="生产能力" width="200px;">
              <template slot-scope="scope">
                <el-form-item
                  :prop="`extTable.${scope.$index}.throughput`"
                  :rules="tableRules.throughput"
                >
                  <el-input
                    style="width: 180px"
                    v-model="scope.row.throughput"
                    placeholder="请输入"
                    clearable
                    maxlength="100"
                  />
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" min-width="200px;">
              <template slot-scope="scope">
                <el-form-item
                  :prop="`extTable.${scope.$index}.remark`"
                  :rules="tableRules.remark"
                >
                  <el-input
                    style="width: 180px"
                    v-model="scope.row.remark"
                    placeholder="请输入"
                    clearable
                    maxlength="255"
                  />
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              width="100px;"
              prop="remark"
              label="操作"
            >
              <template slot-scope="scope">
                <span
                  style="color: red;cursor: pointer;"
                  @click="deleteItem(scope)"
                  >删除</span
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label-width="0px" label="">
          <div class="addBtn" @click="addTable()">+添加设备</div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    extTable: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      checkOut:false,
      tableRules: {
        deviceName: [
          { required: true, message: "请输入设备名称", trigger: "blur" },
          {
            pattern: /^[\u4E00-\u9FA5A-Za-z0-9_]+$/,
            message: "只支持中文、英文、数字"
          }
        ],
        modelSpec: [
          { required: true, message: "请输入型号规格", trigger: "blur" }
        ],
        brand: [
          { required: true, message: "请输入品牌", trigger: "blur" },
          {
            pattern: /^[a-zA-Z\u4e00-\u9fa5]+$/,
            message: "只支持中文或者英文"
          }
        ],
        num: [
          { required: true, message: "请输入数量", trigger: "blur" },
        ],
        buyYear: [{ required: true, message: "请选择出厂年限", trigger: "change" }],
        throughput: [
          { required: true, message: "请输入生产能力", trigger: "blur" }
        ],
        remark: [{ required: true, message: "请输入备注", trigger: "blur" }]
      }
    };
  },
  methods: {
    ruleFun() {

      this.$refs["extTable"].validate(valid => {
        if (valid) {
          this.checkOut=  true;
        } else {
          this.$refs.extTable.$el.scrollIntoView({
            block: "center",
            behavior: "smooth",
          });
          this.checkOut=  false;
        }
      });
    },
    // 新增
    addTable() {
      if (this.extTable && this.extTable.length === 0) {
        this.extTable.push({
          id: 1
        });
      } else {
        this.extTable.push({
          id: this.extTable[this.extTable.length - 1].id + 1
        });
      }
    },
    deleteItem(scope) {
      this.extTable.filter((item, index) => {
        if (item.id === scope.row.id) {
          this.extTable.splice(index, 1);
        }
      });
    },
    changePicker(date, row, value) {
      this.extTable[row.id - 1].buyYear = date;
    },
    // 获取事件
    getDate(dateData) {
      let date = new Date(dateData);
      return date.getFullYear();
    },
    lastStep() {
      this.$emit("getStep", 2);
    }
  },
  watch: {}
};
</script>

<style lang="scss" scoped>
// .fourthStep {
//   // display: flex;
//   // align-items: center; /*垂直居中*/
//   // justify-content: center; /*水平居中*/
// }
.fourthStep {
  display: flex;
  align-items: center; /*垂直居中*/
  justify-content: center; /*水平居中*/
}
.el-table /deep/th.gutter {
  display: table-cell !important;
}
.addBtn {
  cursor: pointer;
  margin: 20px 0px 10px 0px;
  width: 1006px;
  height: 32px;
  line-height: 32px;
  border: 1px dashed #eee;
  border-radius: 4px;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #252631;
}
.addTabIndex {
  width: 100%;
  display: flex;
  align-items: center; /*垂直居中*/
  justify-content: center; /*水平居中*/
}
.addTabIndex /deep/.tbody tr {
  height: 45px !important;
}
/deep/ .el-input--suffix .el-input__inner {
  // padding-right: 25px;
}
/deep/ .el-input__suffix {
  // right: 0px;
  .el-input__clear {
    width: 23px;
  }
}
.addTabIndex /deep/.el-table {
  width: 1006px;
  margin: 0 auto;
  border-bottom: none;
  tbody tr {
    height: 60px !important;
  }
  th>.cell:before{
   content: "*";
   color: red;
   margin-right: 5px;
  }
  th>.cell:before{
    content: "*";
    color: red;
    margin-right: 5px;
  }
  th:nth-child(9)>.cell:before{
    content: "";
    margin-right: 5px;
  }
  th:nth-child(1)>.cell:before{
    content: "";
    margin-right: 5px;
  }
  .addBtn {
    width: 100%;
    height: 32px;
    line-height: 32px;
    border: 1px dashed #eee;
    border-radius: 4px;
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #252631;
  }
}
.table_title {
  width: 100%;
  line-height: 40px;
  border: 1px solid #EDF2FC;
  border-bottom: 0px;
  box-sizing: border-box;
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  background-color: #f8fafd;
}
</style>
